import { combineReducers } from 'redux';
import filterReducer from './containers/filter/filter-reducer';
import libraryReducer from './containers/library/library-reducer';

const reducers = combineReducers({
    filterReducer,
    libraryReducer
});

export default reducers;
